<template>
  <div class="tab-panel-body">
    <!-- Header -->
    <div class="config-section-header">
      <div class="config-section-header__left">
        <v-icon small class="mr-2" color="text_secondary">mdi-folder</v-icon>
        <span class="config-section-label">Pastas</span>
        <v-chip v-if="pastas && pastas.length" x-small class="ml-2" color="surface_tertiary">
          {{ pastas.length }}
        </v-chip>
      </div>
      <ModalAdicionarOuEditarPastas :getPastas="fetch" />
    </div>

    <!-- Table -->
    <DataTables
      v-if="pastas && pastas.length > 0"
      :data="pastas"
      :headers="headers"
      :itens-por-pagina="5"
      tab="pastas"
      class="pastas-table"
      :fetchData="fetch"
    />

    <!-- Empty state -->
    <div v-if="pastas && pastas.length === 0" class="sc-empty-state">
      <v-icon size="40" color="text_secondary" class="mb-3">mdi-folder-open-outline</v-icon>
      <span class="sc-empty-state__title">Nenhuma pasta criada</span>
      <span class="sc-empty-state__subtitle">Crie pastas para organizar as colaborações</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalAdicionarOuEditarPastas from "../../Pastas/ModalAdicionarOuEditarPastas.vue";
import DataTables from "@/components/DataTables.vue";

export default {
  name: "ConfigTabPastas",
  components: { ModalAdicionarOuEditarPastas, DataTables },
  props: {
    codProducao: { type: Number, required: true },
    active: { type: Boolean, default: false },
  },
  watch: {
    active: {
      immediate: true,
      handler(isActive) {
        if (isActive) this.fetch();
      },
    },
    codProducao() {
      if (this.active) this.fetch();
    },
  },
  computed: {
    ...mapGetters({
      pastas: "pastas/getterPastas",
    }),
  },
  data() {
    return {
      headers: [
        {
          text: "Nome da pasta",
          align: "start",
          sortable: false,
          name: "dsc_nome_pasta",
          class: " subtitle-1 font-weight-bold text-center",
          value: "name",
        },
        {
          text: "Ações",
          sortable: false,
          name: "actions",
          align: "end",
          class: "subtitle-1 font-weight-bold pr-7",
          value: "name",
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      getPasta: "pastas/getPastas",
    }),
    async fetch() {
      await this.getPasta({ cod_producao: this.codProducao });
    },
  },
};
</script>

<style lang="scss" scoped>
.pastas-table {
  border-radius: var(--sc-radius-lg);
  overflow: hidden;
}

::v-deep .pastas-table tbody td {
  height: 72px !important;
}

</style>
